export default {
  setSiteResolution: 'setSiteResolution',
  setPages: 'setPages',
  setCoefficient: 'setCoefficient',
  updateActivePageArray: 'updateActivePageArray',
  setAllPagesData: 'setAllPagesData',
  addLocalPage: 'addLocalPage',
  renameLocalPage: 'renameLocalPage',
  patchPageProperties: 'patchPageProperties',
  saveSiteEditorState: 'saveSiteEditorState',
  clearSiteEditorState: 'clearSiteEditorState',
  setEmployeeSearchString: 'setEmployeeSearchString',
  setSearchString: 'setSearchString',
  setEmployees: 'setEmployeeList',
  setAllEmployees: 'setAllEmployees',
  setEmployee: 'setEmployeeObj',
  setDefaultEmployees: 'setDefaultEmployeeList',
  setVisitor: 'setVisitorObj',
  removeVisitor: 'removeVisitor',
  setLocalPageSize: 'setLocalPageSize',
  saveDropinSettings: 'saveDropinSettings',
  validateInput: 'validateInput',
  setTemplateActivePage: 'setTemplateActivePage',
  setCompanyQueueLines: 'setCompanyQueueLines',
  setQueueVisitors: 'setQueueVisitors',
  setJobDepartments: 'setJobDepartments',
  setDepartmentUsers: 'setDepartmentUsers',
  setJobDepartmentUsers: 'setJobDepartmentUsers',
  setJobDepartment: 'setJobDepartment',
  jobDepartments: 'jobDepartments',
  infoSearchCategories: 'infoSearchCategories',
  infoSearchCategory: 'infoSearchCategory',
  infoSearchSubCategory: 'infoSearchSubCategory',
  setInfoSearchCategory: 'setInfoSearchCategory',
  setInfoSearchSubCategory: 'setInfoSearchSubCategory',
  setInfoSearchCategories: 'setInfoSearchCategories',
  setFinishRegisterSettings: 'setFinishRegisterSettings',
  setElementsShifted: 'setElementsShifted',
  setShownContentName: 'setShownContentName',
  parkingRegister: 'parkingRegister',
  taxiOrder: 'taxiOrder',
  graveyard: 'graveyard',
  graveyardGravar: 'graveyardGravar',
  patient: 'patient',
  searchPage: 'searchPage',
  buttonState: 'buttonState',
  shouldAcceptAgreement: 'shouldAcceptAgreement',
  acceptAgreement: 'acceptAgreement',
  showAcceptAgreementPopup: 'showAcceptAgreementPopup',
  saveAfterAgreementHook: 'saveAfterAgreementHook',
  setSearchedPhone: "setSearchedPhone",
};
